module.exports = __webpack_public_path__ + "static/media/intro-animation.68524f8e.png";